import type { CSSProperties } from 'react';

export const MODAL_STYLES = {
  content: {
    background: 'rgba(15, 22, 40, 0.96)',
    backdropFilter: 'blur(20px)',
    WebkitBackdropFilter: 'blur(20px)',
    border: '1px solid rgba(255,255,255,0.08)',
    borderRadius: 16,
    boxShadow: '0 24px 64px rgba(0,0,0,0.60)',
  },
  header: {
    background: 'transparent',
    borderBottom: '1px solid rgba(255,255,255,0.08)',
    paddingBottom: 16,
    color: '#fff',
  },
  body: {
    paddingTop: 20,
  },
  footer: {
    background: 'transparent',
    borderTop: '1px solid rgba(255,255,255,0.08)',
    paddingTop: 16,
  },
  mask: {
    backdropFilter: 'blur(4px)',
    background: 'rgba(0,0,0,0.60)',
  },
};

export const DRAWER_STYLES = {
  body: {
    background: 'rgba(10,10,20,0.97)',
    padding: 24,
  },
  header: {
    background: 'rgba(10,10,20,0.97)',
    borderBottom: '1px solid rgba(255,255,255,0.08)',
    color: '#fff',
  },
  wrapper: {
    background: 'rgba(10,10,20,0.97)',
  },
};

export const MODAL_TITLE_STYLE: CSSProperties = {
  color: '#fff',
  fontSize: 16,
  fontWeight: 600,
};

export const FORM_LABEL_STYLE = {
  label: {
    color: 'rgba(255,255,255,0.70)',
    fontSize: 12,
    fontWeight: 500,
    textTransform: 'uppercase' as const,
    letterSpacing: '0.06em',
  },
};

// Scoped dark theme for forms inside dark modals/drawers.
// Apply via <ConfigProvider theme={darkFormTheme}> around Form inside any Modal
// that uses MODAL_STYLES. Do NOT apply this globally.
export const darkFormTheme = {
  components: {
    Form: {
      labelColor: 'rgba(255,255,255,0.70)',
      labelFontSize: 12,
    },
    Input: {
      colorBgContainer: 'rgba(255,255,255,0.06)',
      colorBorder: 'rgba(255,255,255,0.12)',
      colorText: '#ffffff',
      colorTextPlaceholder: 'rgba(255,255,255,0.30)',
    },
    Select: {
      colorBgContainer: 'rgba(255,255,255,0.06)',
      colorBorder: 'rgba(255,255,255,0.12)',
      colorText: '#ffffff',
      colorBgElevated: 'rgba(15,22,40,0.98)',
      optionSelectedColor: '#F26522',
      optionSelectedBg: 'rgba(242,101,34,0.15)',
    },
    InputNumber: {
      colorBgContainer: 'rgba(255,255,255,0.06)',
      colorBorder: 'rgba(255,255,255,0.12)',
      colorText: '#ffffff',
    },
    DatePicker: {
      colorBgContainer: 'rgba(255,255,255,0.06)',
      colorBorder: 'rgba(255,255,255,0.12)',
      colorText: '#ffffff',
      colorBgElevated: 'rgba(15,22,40,0.98)',
    },
  },
};
